import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userFoto');
    localStorage.removeItem('userCpf');
    localStorage.removeItem('userNome');
    localStorage.removeItem('userApelido');
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMatchesClick = (e) => {
    e.preventDefault();
    navigate('/campeonatos');
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <button className="hamburger" onClick={toggleMenu}>
            <span className="hamburger-icon">
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </span>
          </button>

          <h1 className="logo">
            <Link to="/campeonatos">EsporteSA</Link>
          </h1>

          {/* Links visíveis em telas maiores */}
          <nav className="nav-menu">
            <Link to="/campeonatos">Campeonatos</Link>
            <a href="/matches" onClick={handleMatchesClick}>
              Jogos
            </a>
            <Link to="/my-predictions">Meus Palpites</Link>
            <Link to="/profile">Perfil</Link>
            {userRole === 'administrator' && (
              <>
                <Link to="/times">Times</Link>
              </>
            )}
            {token && (
              <button onClick={handleLogout} className="logout-button">
                Sair
              </button>
            )}
          </nav>
        </div>
      </header>

      <div className={`side-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="side-menu-header">
          <h2>EsporteSA</h2>
          <button className="close-menu" onClick={toggleMenu}>
            ✕
          </button>
        </div>
        <nav className="side-menu-nav">
          <Link to="/campeonatos" onClick={toggleMenu}>
            Campeonatos
          </Link>
          <a href="/matches" onClick={(e) => { handleMatchesClick(e); toggleMenu(); }}>
            Jogos
          </a>
          <Link to="/my-predictions" onClick={toggleMenu}>
            Meus Palpites
          </Link>
          <Link to="/profile" onClick={toggleMenu}>
            Perfil
          </Link>
          {userRole === 'administrator' && (
            <>
              <Link to="/times" onClick={toggleMenu}>
                Times
              </Link>
            </>
          )}
          {token ? (
            <button onClick={handleLogout} className="side-menu-button">
              Sair
            </button>
          ) : (
            <>
              <Link to="/" onClick={toggleMenu} className="side-menu-button login">
                Login
              </Link>
              <Link to="/register" onClick={toggleMenu} className="side-menu-button signup">
                Cadastre-se
              </Link>
            </>
          )}
        </nav>
      </div>

      {isMenuOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}
    </>
  );
}

export default Header;